import { jsx } from "react/jsx-runtime";
import { Modal } from "./Modal.js";
function ModalConfirmation(props) {
  return /* @__PURE__ */ jsx(Modal, {
    ...props
  });
}
export {
  ModalConfirmation
};
//# sourceMappingURL=ModalConfirmation.js.map
